<template>
  <div class="spl-account">
    <second-menu-link-content>
      <template v-slot:header>
        <span>修改资料</span>
      </template>
      <template v-slot:content>
        <div class="main">
          <el-form :label-position="labelPosition" label-width="120px" :model="form">
            <el-form-item label="公司名称：">
              <el-input class="gray" disabled v-model="form.username" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="负责人：">
              <el-input class="gray" v-model="form.head" placeholder="请输入负责人"></el-input>
            </el-form-item>
            <el-form-item label="负责人手机号：" class="mod-phone">
              <el-input class="gray" v-model="form.telephone" placeholder="请输入负责人手机号" disabled></el-input>
              <el-button class="btn-text" type="text" @click="openModPhone">修改手机号</el-button>
            </el-form-item>
            <el-form-item label="密码：">
              <el-input class="gray" v-model="form.password" type="password" placeholder="请设置您的密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码：">
              <el-input
                class="gray"
                v-model="form.surePassword"
                type="password"
                placeholder="再次输入密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-blue" @click="updateInfo">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </second-menu-link-content>
    
    <el-dialog title="修改手机" :visible.sync="dialogVisible" width="420px" top="25vh">
      <!-- 黑色的线条 -->
      <div class="border"></div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <el-form-item label="手机号：" prop="telephone">
          <el-input v-model="ruleForm.telephone" class="gray" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="verificationCode" class="verification-code">
          <el-input v-model.number="ruleForm.verificationCode" class="gray" placeholder="请输入"></el-input>
          <el-button class="btn-blue" @click="getVerificationCode">发送验证码</el-button>
        </el-form-item>
        <!-- 黑色的线条 -->
        <div class="border"></div>
        <el-form-item>
          <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
          <el-button class="btn-blue" @click="save('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script >
import { deleteToken, removeXBPron } from "common/js/storage";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      labelPosition: "right",
      form: {
        username: "",
        head: "",
        telephone: "",
        password: "",
        surePassword: ""
      },
      dialogVisible: false,
      ruleForm: {
        telephone: "",
        verificationCode: ""
      },
      rules: {
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    SecondMenuLinkContent
  },
  created() {
    this.getInformation();
  },
  methods: {
    // 获取当前信息
    getInformation() {
      supplier.getSupplierInfo().then(res => {
        if (res.success) {
          this.form.username = res.result.username;
          this.form.head = res.result.head;
          this.form.telephone = res.result.telephone;
          this.ruleForm.telephone = res.result.telephone;
        }
      });
    },
    // 提交表单
    updateInfo() {
      this.$confirm("资料修改将重新登录?", "提示", {
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        let data = this.form;
        supplier.postUpdateSupplierInfo(data).then(res => {
          if (res.success) {
            deleteToken();
            removeXBPron()
            this.getInformation();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    openModPhone() {
      this.dialogVisible = true;
    },

    getVerificationCode() {
      let telephone = this.ruleForm.telephone;
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (telephone === '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(telephone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
      } else {
        supplier.getSendCode(telephone).then(res => {
          if (!res.success) {
            this.$message.error(res.message);
          }
        });
      }
    },
    
    /* 取消 */
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },

    /* 保存 */
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let newTelephone = this.ruleForm.telephone;
          let code = this.ruleForm.verificationCode;
          let data = {
            newTelephone,
            code,
          };
          supplier.postUpdatePhone(data).then(res => {
            if (res.success) {
              this.reset(formName)
              deleteToken();
              removeXBPron()
              this.getInformation();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  }
};
</script>

<style lang="scss">
.spl-account {
  width: 100%;
  height: 100%;
  .main {
    .el-form {
      padding: 20px 0 0 0px;
      letter-spacing: 1px;
      .el-form-item {
        margin-bottom: 20px;
        .el-form-item__content {
          width: 300px;
          position: relative;
          .btn-text {
            position: absolute;
            right: -80px;
            top: 0px;
            font-size: 14px;
            letter-spacing: 0;
          }
          .btn-blue {
            width: 96px;
            letter-spacing: 4px;
          }
          .el-cascader {
            width: 300px;
          }
        }
      }
    }
  }
  .verification-code {
    display: flex;
    justify-content: flex-start;
    .el-form-item__content {
      margin-left: 0px!important;
      display: flex;
      justify-content: flex-start;
      flex: 1;
      .el-input {
        margin-right: 20px;
      }
    }
  }
}
</style>
